import { render, staticRenderFns } from "./StatsSummary.vue?vue&type=template&id=3a972b8e&scoped=true"
import script from "./StatsSummary.vue?vue&type=script&lang=js"
export * from "./StatsSummary.vue?vue&type=script&lang=js"
import style0 from "./StatsSummary.vue?vue&type=style&index=0&id=3a972b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a972b8e",
  null
  
)

export default component.exports